import { PayloadAction, createSlice } from "@reduxjs/toolkit";
export interface AiSearchState {
  showAiSearchModal: boolean;
  aiTabType: string;
  resultLoader: boolean;
  favouriteLoader: string;
  participantsLoader: boolean;
  aiSearchData: any[];
  currentSearchId: string;
  searchParticipantsData: any[];
  searchParticipantsCount: number;
  participantPage: number;
  toggleFavourite: boolean;
  filters: any;
}

const initialState: AiSearchState = {
  showAiSearchModal: false,
  aiTabType: "aiSearch",
  resultLoader: false,
  favouriteLoader: "",
  participantsLoader: false,
  aiSearchData: [],
  currentSearchId: "",
  searchParticipantsData: [],
  searchParticipantsCount: 0,
  participantPage: 0,
  toggleFavourite: false,
  filters: {},
};

export const aiSearchSlice = createSlice({
  name: "aiSearch",
  initialState: initialState,
  reducers: {
    setShowAiSearchModal: (state, action: PayloadAction<boolean>) => {
      state.showAiSearchModal = action.payload;
    },

    setAiTabType: (state, action: PayloadAction<string>) => {
      state.aiTabType = action.payload;
    },
    setFilters: (state, action: PayloadAction<any>) => {
      state.filters = action.payload;
      state.participantPage = 0;
    },

    setResultLoader: (state, action: PayloadAction<boolean>) => {
      state.resultLoader = action.payload;
    },

    setAiSearchQuery: (
      state,
      action: PayloadAction<{
        tempId: string;
        userInput: string;
        favourite: boolean;
      }>
    ) => {
      state.aiSearchData.push({
        id: action.payload.tempId,
        userInput: action.payload.userInput,
        favourite: action.payload.favourite,
        count: null,
        response: null,
      });
    },

    updateAiSearchResponse: (
      state,
      action: PayloadAction<{
        tempId: string;
        id: string;
        response: any[];
        count: number;
      }>
    ) => {
      const queryObject = state.aiSearchData.find(
        (item) => item.id === action.payload.tempId
      );
      if (queryObject) {
        queryObject.id = action.payload.id;
        queryObject.response = action.payload.response;
        queryObject.count = action.payload.count;
      }
    },

    setFavouriteLoader: (state, action: PayloadAction<string>) => {
      state.favouriteLoader = action.payload;
    },

    updateQueryFavourite: (
      state,
      action: PayloadAction<{
        id: string;
        favourite: boolean;
      }>
    ) => {
      const queryObject = state.aiSearchData.find(
        (item) => item.id === action.payload.id
      );
      if (queryObject) {
        queryObject.favourite = action.payload.favourite;
      }
    },

    setToggleFavourite: (state) => {
      state.toggleFavourite = !state.toggleFavourite;
    },

    setCurrentSearchId: (state, action: PayloadAction<string>) => {
      state.currentSearchId = action.payload;
      state.searchParticipantsData = [];
      state.searchParticipantsCount = 0;
      state.participantPage = 0;
      state.showAiSearchModal = false;
    },

    setSearchParticipantsLoader: (state, action: PayloadAction<boolean>) => {
      state.participantsLoader = action.payload;
    },

    setSearchParticipants: (state, action: PayloadAction<any>) => {
      state.searchParticipantsData = action.payload;
    },

    setSearchParticipantsCount: (state, action: PayloadAction<number>) => {
      state.searchParticipantsCount = action.payload;
    },

    setSearchParticipantsPage: (state, action: PayloadAction<number>) => {
      state.participantPage = action.payload;
    },
  },
});

export const {
  setShowAiSearchModal,
  setAiTabType,
  setResultLoader,
  setAiSearchQuery,
  updateAiSearchResponse,
  setFavouriteLoader,
  updateQueryFavourite,
  setCurrentSearchId,
  setSearchParticipantsLoader,
  setSearchParticipants,
  setSearchParticipantsCount,
  setSearchParticipantsPage,
  setToggleFavourite,
  setFilters,
} = aiSearchSlice.actions;

export default aiSearchSlice.reducer;
